var _circle, _circle2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsaFlag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 39.1304,
    fill: "white",
    stroke: "#F9F6F9",
    strokeWidth: 1.73913
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.9999,
    cy: 40.0001,
    r: 34.7826,
    fill: "#FAFAFA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.936 25.2807L32.5811 26.1817L34.9521 26.3556V41.8775H18.1103C17.4687 40.5254 16.7592 39.2064 15.9844 37.9259V36.3453L16.7747 34.7646V32.3937L19.936 25.2807Z",
    fill: "#0254F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5166 45.8291H57.0811L57.1206 45.8686C56.6227 46.7459 56.2908 47.4098 56.2908 47.4098L57.4763 49.7807H53.9989C53.5592 49.3255 52.9697 49.0448 52.3392 48.9904C50.9809 48.9709 49.6339 49.2403 48.3876 49.7807H32.9763L31.7908 48.2001H28.6295C26.9407 48.0823 25.3093 47.5385 23.8876 46.6194L21.5166 45.8291Z",
    fill: "#EAFEFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2425 38.7162V41.8775H34.9521V37.9259H60.2425V38.7162Z",
    fill: "#EAFEFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8715 31.6033L58.4247 29.9436L58.6618 30.0227H62.6134L63.4037 32.3936L61.1276 34.1007L61.0328 33.9743H54.7102L54.394 33.8162L55.5005 31.6033H57.8715Z",
    fill: "#EAFEFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3365 30.0227L46.807 30.813V33.9743H34.9521V30.0227H47.3365Z",
    fill: "#EAFEFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4762 49.7807L58.6617 52.1517L57.081 54.5227C57.081 54.5227 55.7059 51.314 53.9988 49.7807H57.4762Z",
    fill: "#EE0A00"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9763 49.7807H48.3876V51.3614C46.8326 50.9623 45.2461 50.6978 43.6457 50.5711C42.065 50.5711 40.4844 55.313 40.4844 55.313H38.9037L36.5328 51.3614H34.1618L32.9763 49.7807Z",
    fill: "#EE0A00"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9521 41.8775H60.2425C59.2545 42.3675 57.9584 44.4065 57.1207 45.8686L57.0812 45.8291H21.5166C21.5166 45.8291 18.3554 43.4581 18.3554 42.6678C18.3177 42.3927 18.2349 42.1257 18.1104 41.8775H34.9521Z",
    fill: "#EE0A00"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2425 34.7646V37.9259H34.9521V33.9743H46.807L49.178 34.7646V33.9743H52.3392V34.7646H53.9199L54.3941 33.8162L54.7102 33.9743H61.0328L61.1276 34.1007L60.2425 34.7646Z",
    fill: "#EE0A00"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8232 28.442L62.6135 25.2807H64.1942L64.9845 27.6517C64.9845 28.442 62.6135 30.0227 62.6135 30.0227H58.6619L58.4248 29.9436L58.6619 29.2323L61.8232 28.442Z",
    fill: "#EE0A00"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3876 28.442L47.3365 30.0227H34.9521V26.3556L42.0651 26.8614L48.3876 28.442Z",
    fill: "#EE0A00"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1296 48.9904C52.917 48.9904 52.7194 49.0031 52.5203 49.0149C53.0796 49.1137 53.5955 49.3808 53.999 49.7807H54.7893C54.3497 49.3255 53.7601 49.0448 53.1296 48.9904Z",
    fill: "#BFCCD6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7891 49.7807H53.9988C55.7059 51.314 57.081 54.5227 57.081 54.5227L57.5457 53.8256C56.8628 52.3308 55.9306 50.963 54.7891 49.7807Z",
    fill: "#A30907"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1053 33.9743L55.1844 33.8162L56.2908 31.6033H55.5005L54.394 33.8162L54.7102 33.9743H55.1053Z",
    fill: "#BFCCD6"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M59.189 30.0227H58.6619L58.4248 29.9436L57.8716 31.6033H58.6619L59.189 30.0227Z",
    fill: "#BFCCD6"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1054 33.9743H54.7102L54.3941 33.8162L53.9199 34.7646H54.7102L55.1054 33.9743Z",
    fill: "#A30907"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M59.189 30.0227L59.2151 29.9436L59.4522 29.2323L62.6135 28.442L63.4038 25.2807H62.6135L61.8232 28.442L58.6619 29.2323L58.4248 29.9436L58.6619 30.0227H59.189Z",
    fill: "#A30907"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1457 37.9259V36.3453L19.936 34.7646V32.3937L23.0001 25.4989L19.936 25.2807L16.7747 32.3937V34.7646L15.9844 36.3453V37.9259C16.7592 39.2064 17.4687 40.5254 18.1103 41.8775H21.2716C20.63 40.5254 19.9205 39.2064 19.1457 37.9259Z",
    fill: "#0134A1"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9521 48.2001H31.7908L32.9763 49.7807H36.1375L34.9521 48.2001Z",
    fill: "#EAFEFF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6779 45.8291H21.5166L23.8876 46.6194C25.3093 47.5385 26.9407 48.0823 28.6295 48.2001H31.7908C30.102 48.0823 28.4706 47.5385 27.0489 46.6194L24.6779 45.8291Z",
    fill: "#BFCCD6"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3231 51.3614L36.1376 49.7807H32.9763L34.1618 51.3614H36.5328L38.9037 55.313H40.4844C40.4844 55.313 40.7215 54.5954 41.1095 53.7197L39.6941 51.3614H37.3231Z",
    fill: "#A30907"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5166 42.6678C21.479 42.3927 21.3962 42.1257 21.2716 41.8775H18.1104C18.2349 42.1257 18.3177 42.3927 18.3554 42.6678C18.3554 43.4581 21.5166 45.8291 21.5166 45.8291H24.6779C24.6779 45.8291 21.5166 43.4581 21.5166 42.6678Z",
    fill: "#A30907"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5811 26.0711L32.8253 26.5911L33.3714 26.7033L32.9763 27.0795L33.0553 27.6517L32.5811 27.3814L32.1069 27.6517L32.1859 27.0795L31.7908 26.7033L32.3369 26.5911L32.5811 26.0711Z",
    fill: "#EAFEFF"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8392 26.0711L28.0834 26.5911L28.6295 26.7033L28.2343 27.0795L28.3133 27.6517L27.8392 27.3814L27.365 27.6517L27.444 27.0795L27.0488 26.7033L27.5949 26.5911L27.8392 26.0711Z",
    fill: "#EAFEFF"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0972 26.0711L23.3414 26.5911L23.8875 26.7033L23.4924 27.0795L23.5714 27.6517L23.0972 27.3814L22.623 27.6517L22.702 27.0795L22.3069 26.7033L22.853 26.5911L23.0972 26.0711Z",
    fill: "#EAFEFF"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2102 29.2323L30.4545 29.7524L31.0006 29.8646L30.6054 30.2408L30.6844 30.813L30.2102 30.5427L29.7361 30.813L29.8151 30.2408L29.4199 29.8646L29.966 29.7524L30.2102 29.2323Z",
    fill: "#EAFEFF"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4683 29.2323L25.7125 29.7524L26.2586 29.8646L25.8635 30.2408L25.9425 30.813L25.4683 30.5427L24.9941 30.813L25.0731 30.2408L24.678 29.8646L25.2241 29.7524L25.4683 29.2323Z",
    fill: "#EAFEFF"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7264 29.2323L20.9706 29.7524L21.5167 29.8646L21.1215 30.2408L21.2006 30.813L20.7264 30.5427L20.2522 30.813L20.3312 30.2408L19.936 29.8646L20.4821 29.7524L20.7264 29.2323Z",
    fill: "#C7CCC6"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5811 32.3936L32.8253 32.9137L33.3714 33.0259L32.9763 33.4021L33.0553 33.9743L32.5811 33.704L32.1069 33.9743L32.1859 33.4021L31.7908 33.0259L32.3369 32.9137L32.5811 32.3936Z",
    fill: "#EAFEFF"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8392 32.3936L28.0834 32.9137L28.6295 33.0259L28.2343 33.4021L28.3133 33.9743L27.8392 33.704L27.365 33.9743L27.444 33.4021L27.0488 33.0259L27.5949 32.9137L27.8392 32.3936Z",
    fill: "#EAFEFF"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0972 32.3936L23.3414 32.9137L23.8875 33.0259L23.4924 33.4021L23.5714 33.9743L23.0972 33.704L22.623 33.9743L22.702 33.4021L22.3069 33.0259L22.853 32.9137L23.0972 32.3936Z",
    fill: "#EAFEFF"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3553 32.3936L18.5995 32.9137L19.1456 33.0259L18.7504 33.4021L18.8295 33.9743L18.3553 33.704L17.8811 33.9743L17.9601 33.4021L17.5649 33.0259L18.1111 32.9137L18.3553 32.3936Z",
    fill: "#C7CCC6"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2102 35.5549L30.4545 36.075L31.0006 36.1872L30.6054 36.5634L30.6844 37.1356L30.2102 36.8653L29.7361 37.1356L29.8151 36.5634L29.4199 36.1872L29.966 36.075L30.2102 35.5549Z",
    fill: "#EAFEFF"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4683 35.5549L25.7125 36.075L26.2586 36.1872L25.8635 36.5634L25.9425 37.1356L25.4683 36.8653L24.9941 37.1356L25.0731 36.5634L24.678 36.1872L25.2241 36.075L25.4683 35.5549Z",
    fill: "#EAFEFF"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7264 35.5549L20.9706 36.075L21.5167 36.1872L21.1215 36.5634L21.2006 37.1356L20.7264 36.8653L20.2522 37.1356L20.3312 36.5634L19.936 36.1872L20.4821 36.075L20.7264 35.5549Z",
    fill: "#EAFEFF"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5811 38.7162L32.8253 39.2363L33.3714 39.3485L32.9763 39.7247L33.0553 40.2969L32.5811 40.0266L32.1069 40.2969L32.1859 39.7247L31.7908 39.3485L32.3369 39.2363L32.5811 38.7162Z",
    fill: "#EAFEFF"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8392 38.7162L28.0834 39.2363L28.6295 39.3485L28.2343 39.7247L28.3133 40.2969L27.8392 40.0266L27.365 40.2969L27.444 39.7247L27.0488 39.3485L27.5949 39.2363L27.8392 38.7162Z",
    fill: "#EAFEFF"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0972 38.7162L23.3414 39.2363L23.8875 39.3485L23.4924 39.7247L23.5714 40.2969L23.0972 40.0266L22.623 40.2969L22.702 39.7247L22.3069 39.3485L22.853 39.2363L23.0972 38.7162Z",
    fill: "#EAFEFF"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3553 38.7162L18.5995 39.2363L19.1456 39.3485L18.7504 39.7247L18.8295 40.2969L18.3553 40.0266L17.8811 40.2969L17.9601 39.7247L17.5649 39.3485L18.1111 39.2363L18.3553 38.7162Z",
    fill: "#C7CCC6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsaFlag);
export default __webpack_public_path__ + "static/media/usa-flag.6fcaa774e91c313dd2652b3c7b8c786e.svg";
export { ForwardRef as ReactComponent };